import { Component } from '@angular/core';
import { Plugins } from "@capacitor/core";
import { Network } from '@capacitor/network';
import { StatusBar, Style } from '@capacitor/status-bar';
import { ModalController, Platform } from '@ionic/angular';
import { ApiService } from './services/api/api.service';
import { AuthService } from './services/auth/auth.service';
import { ComponentsService } from './services/components/components.service';
import { PrintService } from './services/print/print.service';
const { Device } = Plugins;

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
})
export class AppComponent {
    device: any;
    connected: any = true;

    constructor(
        private platform: Platform,
        public modalController: ModalController,
        public components: ComponentsService,
        public auth: AuthService,
        public api: ApiService,
        private print: PrintService
    ) {
        this.initializeApp();
    }

    initializeApp() {
        this.platform.ready().then(() => {
            this.components.isDesktop = (!this.platform.is('cordova'));

            if (!this.components.isDesktop) {

                this.api.getDocument('quanto', 'general').then(async data => {
                    let general = JSON.parse(JSON.stringify(data));
                })
            }

            // if (this.platform.is('ios') || this.platform.is('android')) {
            //     Network.addListener('networkStatusChange', (status) => {
            //         if (status.connected) {
            //             if (!this.auth.account_key) {
            //                 this.auth.init();
            //             } else {
            //                 this.connected = true;
            //             }
            //         } else {
            //             this.connected = false;
            //             this.auth.lockUser();
            //         }
            //     });
            //     this.tryConnection();
            // }

            if (this.platform.is('cordova')) {
                this.setStatusBar();
            }

            console.log('%c¡DETENTE!', 'font-size: 30px; background: black; color: red');
            console.log('%cEsta función del navegador está pensada para desarrolladores. Si alguien te indicó que copiaras y pegaras algo aquí para habilitar una función de Quanto o para "hackear" la cuenta de alguien, se trata de un fraude. Si lo haces, esta persona podrá acceder a tu cuenta. Gracias F.Yorch', 'font-size: 18px; background: black; color: white');

        });
    }

    compareVersion(v1: string, v2: string): number {
        const last_version = v1.split(".").map(x => parseInt(x));
        const app_version = v2.split(".").map(x => parseInt(x));
        const maxLength = Math.max(last_version.length, app_version.length);

        for (let i = 0; i < maxLength; i++) {
            const v1Component = last_version[i] || 0;
            const v2Component = app_version[i] || 0;
            if (v1Component < v2Component) {
                return -1;
            } else if (v1Component > v2Component) {
                return 1;
            }
        }
        return 0;
    }

    convertToHours(date: any) {
        var time = date;
        var hours = Number(time.match(/^(\d+)/)[1]);
        var minutes = Number(time.match(/:(\d+)/)[1]);
        var AMPM = time.match(/\s(.*)$/)[1];
        if (AMPM == "PM" && hours < 12) hours = hours + 12;
        if (AMPM == "AM" && hours == 12) hours = hours - 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        return sHours + ":" + sMinutes;
    }

    async setStatusBar() {
        await StatusBar.show();
        await StatusBar.setStyle({ style: Style.Light });
    }

    convertToDate(date: any) {
        return `${new Date(date).getDate()}/${new Date(date).getMonth() + 1}/${new Date(date).getFullYear()}`;
    }

    tryConnection() {
        Network.getStatus().then(data => {
            if (data.connected) {
                if (!this.auth.account_key) {
                    this.auth.init();
                } else {
                    this.connected = true;
                }
            } else {
                this.connected = false;
                this.auth.lockUser();
            }
        })
    }
}
